module.exports = __webpack_public_path__ + "img/nbhotmeter.ebd6cc6e.png";